module.exports = __webpack_public_path__ + "static/media/1.d4a810cd.mp3";